var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["tr", "tr--" + _vm.tone] }, [
    _c("div", { staticClass: "tr__head" }, [
      _c("i", { class: ["feather", _vm.icon, "tr__icon"] }),
      _c("div", [
        _c("div", { staticClass: "tr__verdict" }, [
          _vm._v(_vm._s(_vm.result.message)),
        ]),
        _vm.result.item && _vm.result.item.name
          ? _c("div", { staticClass: "tr__item" }, [
              _vm._v(_vm._s(_vm.result.item.name)),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm.holderName
      ? _c("div", { staticClass: "tr__holder" }, [
          _c("div", { staticClass: "tr__holder-name" }, [
            _vm._v(_vm._s(_vm.holderName)),
          ]),
          _vm.holderDocument
            ? _c("div", { staticClass: "tr__holder-doc" }, [
                _vm._v("CPF " + _vm._s(_vm.holderDocument)),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.occurrence
      ? _c("dl", { staticClass: "tr__facts" }, [
          _vm.occurrence.date
            ? _c("div", [
                _c("dt", [_vm._v("Sessão")]),
                _c("dd", [
                  _vm._v(_vm._s(_vm.formattedDate)),
                  _vm.occurrence.start_time
                    ? _c("span", [
                        _vm._v(" · " + _vm._s(_vm.occurrence.start_time)),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm.occurrence.origin_label
            ? _c("div", [
                _c("dt", [_vm._v("Origem")]),
                _c("dd", [_vm._v(_vm._s(_vm.occurrence.origin_label))]),
              ])
            : _vm._e(),
          _vm.result.ticket && _vm.result.ticket.code
            ? _c("div", [
                _c("dt", [_vm._v("Código")]),
                _c("dd", [_vm._v(_vm._s(_vm.result.ticket.code))]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.showPreviousEntry
      ? _c(
          "p",
          { staticClass: "tr__note" },
          [
            _vm._v(
              " Entrada registrada às " +
                _vm._s((_vm.result.check_in.at || "").slice(11, 16)) +
                " "
            ),
            _vm.result.check_in.validated_by &&
            _vm.result.check_in.validated_by.name
              ? [
                  _vm._v(
                    " por " +
                      _vm._s(_vm.result.check_in.validated_by.name) +
                      " "
                  ),
                ]
              : _vm._e(),
            _vm._v(". "),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }